module.exports = new __parcel__URL__("people-working-on-computers.8a5759a8.svg").toString();